import { Injectable, OnDestroy } from '@angular/core';
import { FlowSteps } from '../models/FlowSteps';
import { ProductCodeRange } from '../models/LeadProducts';
import { StepProgress } from '../models/StepProgress';
import { surveySectionId } from '../models/SurveySectionId';

@Injectable({
  providedIn: 'root',
})
export class ConstantService implements OnDestroy {
  internalSteps: FlowSteps[] = new Array<FlowSteps>();

  private surveySteps: StepProgress[] = [
    // {
    //   StepId: 1,
    //   StepName: 'SurveySteps.Simulation',
    //   LastStep: false,
    //   StepNumber: surveySectionId.simulationModuleOne,
    // },
    {
      StepId: 1,
      StepName: 'SurveySteps.Identification',
      LastStep: false,
      StepNumber: surveySectionId.identification,
    },
    {
      StepId: 2,
      StepName: 'SurveySteps.Budget',
      LastStep: false,
      StepNumber: surveySectionId.finance,
    },
    {
      StepId: 3,
      StepName: 'SurveySteps.Risk',
      LastStep: false,
      StepNumber: surveySectionId.risk,
    },
    {
      StepId: 4,
      StepName: 'SurveySteps.Knowledge',
      LastStep: false,
      StepNumber: surveySectionId.knowledgeIntro,
    },
    {
      StepId: 5,
      StepName: 'SurveySteps.Sustainability',
      LastStep: false,
      StepNumber: surveySectionId.sustainability,
    },
    {
      StepId: 6,
      StepName: 'SurveySteps.Advice',
      LastStep: false,
      StepNumber: surveySectionId.advice,
    },
    {
      StepId: 7,
      StepName: 'SurveySteps.Onboarding',
      LastStep: true,
      StepNumber: surveySectionId.onboarding,
    },
  ];

  private ltsSurveySteps: StepProgress[] = [
    // StepNames need to be updated
    {
      StepId: 1,
      StepName: 'LtsSurveySteps.Welcome',
      LastStep: false,
      StepNumber: surveySectionId.welcome,
    },
    {
      StepId: 2,
      StepName: 'LtsSurveySteps.Identification',
      LastStep: false,
      StepNumber: surveySectionId.identification,
    },
    {
      StepId: 3,
      StepName: 'LtsSurveySteps.Needs',
      LastStep: false,
      StepNumber: surveySectionId.needs,
    },
    {
      StepId: 4,
      StepName: 'LtsSurveySteps.Budget',
      LastStep: false,
      StepNumber: surveySectionId.budget,
    },
    {
      StepId: 5,
      StepName: 'LtsSurveySteps.Risk',
      LastStep: false,
      StepNumber: surveySectionId.risk,
    },
    {
      StepId: 6,
      StepName: 'LtsSurveySteps.Knowledge',
      LastStep: false,
      StepNumber: surveySectionId.knowledgeIntro,
    },
    {
      StepId: 7,
      StepName: 'LtsSurveySteps.Advice',
      LastStep: false,
      StepNumber: surveySectionId.advice,
    },
    {
      StepId: 8,
      StepName: 'LtsSurveySteps.Onboarding',
      LastStep: true,
      StepNumber: surveySectionId.onboarding,
    },
  ];
  private yongoSteps: StepProgress[] = [
    // StepNames need to be updated
    {
      StepId: 1,
      StepName: 'YongoSteps.Identification',
      LastStep: false,
      StepNumber: surveySectionId.identification,
    },
    {
      StepId: 2,
      StepName: 'YongoSteps.Formule',
      LastStep: false,
      StepNumber: surveySectionId.formula,
    },
    {
      StepId: 3,
      StepName: 'YongoSteps.Child',
      LastStep: false,
      StepNumber: surveySectionId.kid,
    },
    {
      StepId: 4,
      StepName: 'YongoSteps.Knowledge',
      LastStep: false,
      StepNumber: surveySectionId.knowledge,
    },
    {
      StepId: 5,
      StepName: 'YongoSteps.Signature',
      LastStep: true,
      StepNumber: surveySectionId.contract,
    }
  ];

  constructor() {
    this.internalSteps.push(
      new FlowSteps(ProductCodeRange.Uppie, this.surveySteps)
    );
    this.internalSteps.push(
      new FlowSteps(ProductCodeRange.Zennie, this.ltsSurveySteps)
    );
    this.internalSteps.push(
      new FlowSteps(ProductCodeRange.Yongo, this.yongoSteps)
    );
  }
  public steps(code: ProductCodeRange): StepProgress[] {
    return this.internalSteps.find((x) => x.flowId === code)?.stepProgresses ?? [];
  }
  ngOnDestroy(): void {
    console.log('Core Store Service is destroyed');
  }
  public  get flowSteps(): FlowSteps[] {
    return this.internalSteps;
  }
}
